import { render, staticRenderFns } from "./SetTag.vue?vue&type=template&id=87a19ab8&scoped=true"
import script from "./SetTag.vue?vue&type=script&lang=js"
export * from "./SetTag.vue?vue&type=script&lang=js"
import style0 from "./SetTag.vue?vue&type=style&index=0&id=87a19ab8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a19ab8",
  null
  
)

export default component.exports